import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isCreateOrganizationalUnitRequestFailure() {
      return getState().isFailure;
    },
    isCreateOrganizationalUnitRequestPending() {
      return getState().isPending;
    },
    isCreateOrganizationalUnitRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
